import { FC } from 'react';
import { IconProps } from 'react-feather';
import styled from 'styled-components';
import * as Icon from 'react-feather';
import {
  colorGold,
  colorPurple,
  colorTableOperationIcon,
} from '@atlas-frontend/design-tokens';
import { Bullet } from '@atlas-frontend/sdk';

interface SampleSubjectLockIconProps extends IconProps {
  isLocked: boolean | 'some';
  showBullet?: boolean;
}

export const SampleSubjectLockIcon: FC<SampleSubjectLockIconProps> = ({
  isLocked,
  showBullet,
  ...rest
}) => (
  <IconWrapper>
    {isLocked === 'some' ? (
      <PartiallyLockedIcon
        name="partial-lock"
        role="img"
        size={18}
        {...(rest as any)}
      />
    ) : isLocked ? (
      <LockedIcon name="lock" role="img" size={18} {...(rest as any)} />
    ) : (
      <UnlockedIcon name="unlock" role="img" size={18} {...(rest as any)} />
    )}
    {showBullet && (
      <BulletWrapper>
        <Bullet color={colorGold[6]} />
      </BulletWrapper>
    )}
  </IconWrapper>
);

export const PartiallyLockedIcon: typeof Icon.Lock = styled(Icon.Lock)`
  color: ${colorPurple[6]};
  rect {
    fill: currentColor;
  }
`;

export const LockedIcon: typeof Icon.Lock = styled(Icon.Lock)`
  color: ${colorTableOperationIcon};
  rect {
    fill: currentColor;
  }
`;

export const UnlockedIcon: typeof Icon.Unlock = styled(Icon.Unlock)`
  color: ${colorTableOperationIcon};
`;

const IconWrapper = styled.div`
  position: relative;
  display: inline-block;
  width: 18px;
  height: 18px;
  line-height: 0;
  vertical-align: top;
`;

const BulletWrapper = styled.div`
  position: absolute;
  top: 1px;
  right: 1px;
`;
